document.addEventListener('DOMContentLoaded', function () {
  var directSubscriptionKey = sessionStorage.getItem('floraiDirectSubscriptionKey');
  if (directSubscriptionKey) {
    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(shopRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: directSubscriptionKey, quantity: 0 })
    }).then(function (response) {
      sessionStorage.removeItem('floraiDirectSubscriptionKey');
      if (response.ok) window.location.reload();
    }).catch(function () {
      sessionStorage.removeItem('floraiDirectSubscriptionKey');
    });
  }

  document.querySelectorAll('.florai-card__form').forEach(function (form) {
    if (!form.querySelector('[data-florai-flower-card]')) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.textContent = 'Opening gifts...';
      }
      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (response) {
        if (!response.ok) throw new Error();
        return response.json();
      }).then(function (item) {
        if (item && item.key) sessionStorage.setItem('floraiGiftFlowFlowerKey', item.key);
        window.location.assign(shopRoot + 'pages/add-gifts');
      }).catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = 'Add to Cart';
        }
        window.alert('The order could not be started. Please try again.');
      });
    }, true);
  });

  document.querySelectorAll('[data-florai-hero]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-florai-slide]');
    var dots = root.querySelectorAll('[data-florai-dot]');
    if (!slides.length) return;
    var index = 0;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }
    show(0);
    var prevButton = root.querySelector('[data-florai-prev]');
    var nextButton = root.querySelector('[data-florai-next]');
    if (prevButton) prevButton.addEventListener('click', function () { show(index - 1); });
    if (nextButton) nextButton.addEventListener('click', function () { show(index + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });
  });

  document.querySelectorAll('[data-florai-postcode]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input');
      var result = form.querySelector('[data-florai-postcode-result]');
      if (!result) return;
      var value = (input.value || '').trim();
      var uk = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i;
      result.hidden = false;
      if (uk.test(value)) {
        result.textContent = '✓ Great news! Same Day & Next Day delivery available for ' + value.toUpperCase() + '.';
      } else {
        result.textContent = 'Enter a valid UK postcode, for example SW1A 1AA.';
      }
    });
  });
});
